import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

const onSelectDropdownValue = (index, newAppTexts, value, setCorrectColumnToCorrectTitle) => {
  const chooseValueFromAppTexts = newAppTexts.map(a => a.name === value).indexOf(true);
  setCorrectColumnToCorrectTitle(index, newAppTexts[chooseValueFromAppTexts]);
};

const ImportFileDropdown = ({
  newAppTexts,
  importedFileTitleRow,
  index,
  setCorrectColumnToCorrectTitle,
  placeholder,
}) => (
  <Select
    className="import-file-dropdown-select"
    onBlurResetsInput={false}
    onSelectResetsInput={false}
    disabled={false}
    valueKey={'name'}
    labelKey={'text'}
    options={newAppTexts}
    simpleValue
    placeholder={placeholder}
    value={importedFileTitleRow[index] && importedFileTitleRow[index].text === null ? placeholder : importedFileTitleRow[index]}
    onChange={value => onSelectDropdownValue(index, newAppTexts, value, setCorrectColumnToCorrectTitle)}
  />
);

ImportFileDropdown.propTypes = {
  newAppTexts: PropTypes.array,
  importedFileTitleRow: PropTypes.array,
  index: PropTypes.number,
  setCorrectColumnToCorrectTitle: PropTypes.func,
  placeholder: PropTypes.string,
};

export default ImportFileDropdown;



// WEBPACK FOOTER //
// ./src/components/organisms/ImportFile/blocks/importFileDropdown.js